module.exports = __webpack_public_path__ + "img/nav-design-collectionrings@2x.58beda3.webp";